import {
  BlockTypes,
  IBlock,
  IServiceBlock,
  ITextBlock,
  ITitlePageBlock,
  useBlocksActions,
  useBlocksStore,
} from '@/models/commercial-proposals/blocks.store';
import { DragDropContext, DropResult, Droppable } from '@hello-pangea/dnd';
import { memo } from 'react';
import ServicesBlock from './ServicesBlock';
import TextBlock from './TextBlock';
import TitlePageBlock from './TitlePageBlock';

const Renderer = memo(function Renderer({
  block,
  index,
}: {
  block: IBlock;
  index: number;
}) {
  switch (block.type) {
    case BlockTypes.TitlePage:
      return (
        <TitlePageBlock
          key={block.uuid}
          block={block as ITitlePageBlock}
          index={index}
        />
      );
    case BlockTypes.Text:
      return (
        <TextBlock key={block.uuid} block={block as ITextBlock} index={index} />
      );
    case BlockTypes.ServicesInThreePackages:
    case BlockTypes.ServicesInTwoPackages:
    case BlockTypes.ServicesInOnePackage:
    case BlockTypes.Services:
      return (
        <ServicesBlock
          key={block.uuid}
          block={block as IServiceBlock}
          index={index}
        />
      );
    default:
      return null;
  }
});

export default function BlocksView() {
  const blocks = useBlocksStore((state) => state.blocks);
  const { reorder } = useBlocksActions();

  return (
    <DragDropContext
      onDragEnd={(result: DropResult) => {
        if (!result.destination) return;
        const sourceIndex = result.source.index;
        const destinationIndex = result.destination.index;
        if (sourceIndex === destinationIndex) return;
        reorder(sourceIndex, destinationIndex);
      }}
    >
      <Droppable droppableId="content-blocks">
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={(el) => {
              provided.innerRef(el);
            }}
            className="no-block-deselect"
          >
            {blocks.map((block, i) => (
              <Renderer key={block.uuid} block={block} index={i} />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
